import Vue from 'vue';
Vue.mixin({
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!!from.name) vm.$EventBus.$off(`${from.name}_refresh`);
      if (!!to.name) {
        vm.$EventBus.$off(`${to.name}_refresh`);
        if (!!vm[vm.applyName || 'initList']) {
          vm.$EventBus.$on(`${to.name}_refresh`, vm[vm.applyName || 'initList']);
        }
      }
    });
  }
})